import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { NotesService } from '../../../services/notes.service';
import moment from 'moment';
import { MessagingService } from '../../../services/messaging.service';
import {NoteDataModel} from '../../../models/notes/note-data.model';
import {EnumValidValueModel} from '../../../models/enum/enum-valid-value.model';
import {NoteGroupDataModel} from '../../../models/notes/note-group-data.model';
import {MessagingConstants} from '../../../models/MessagingConstants';

@Component({
  standalone: false,
  selector: 'app-note-inline',
  templateUrl: './note-inline.component.html',
  styleUrls: ['./note-inline.component.css']
})
export class NoteInlineComponent implements OnInit {
  @ViewChild('scrollContainer') scrollContainer: ElementRef;

  @Input() listenToNoteQueryEvents: boolean = true;
  @Input() PatientID: string = '';
  @Input() PatientName: string = '';
  @Input() NoteGroupId: string = '';
  @Input() ParentObjectName: string = '';
  @Input() ObjectId: string = '';
  messagingSubscription: any;

  public dataNoteCategoryEnums: EnumValidValueModel;
  public dataNoteTypeEnums: EnumValidValueModel;

  dataNoteGroups: NoteGroupDataModel[] = [];

  constructor(private notesService: NotesService,
              private messagingService: MessagingService) { }

  private buildGetNoteGroupQuery(): any {
    const query = {
      PatientID: this.PatientID,
      NoteGroupId: this.NoteGroupId,
      ObjectID: this.ObjectId,
    };

    return query;
  }

  async ngOnInit() {
    try {
      this.dataNoteCategoryEnums = await this.notesService.getNoteCategoryEnums().toPromise();
      this.dataNoteTypeEnums = await this.notesService.getNoteTypeEnums().toPromise();

      await this.initNotes();
    }
    catch (e) {
      this.messagingService.sendComponentMessage('notesDisplayWarning', {
        message: 'Whoops... something went wrong'
      });
    }

    this.messagingSubscription = this.messagingService.componentMessageCall
      .subscribe(async (response) => {

        if (response.event === MessagingConstants.PATIENT_CHANGED && this.listenToNoteQueryEvents) {
          if (response.data.clearCurrentQuery) {
            this.clearCurrentQuery();
          }

          this.PatientID = response.data.PatientID;
          this.PatientName = response.data.PatientName;
          this.ObjectId = response.data.PatientID;

          await this.initNotes();
        }

      });

    console.log('loaded');
  }

  private async initNotes() {
    if (this.PatientID.trim() === '' || this.PatientName.trim() === '' || this.ParentObjectName.trim() === '' || this.ObjectId.trim() === '') {
      throw new Error(('Inline note requires: PatientID, PatientName, ParentObjectName and ObjectID'));
    }

    this.dataNoteGroups = await this.notesService.getNoteByQuery(this.buildGetNoteGroupQuery()).toPromise();

    const today = moment();
    this.dataNoteGroups.forEach(o => {
      const noteDate: moment.Moment = moment(o.dataNote.xauditCreatedOn);

      o.isEditable = today.diff(noteDate, 'h') < 24;
    });
  }

  private clearCurrentQuery() {
    this.PatientID = null;
    this.NoteGroupId = null;
    this.ObjectId = null;
    this.ParentObjectName = null;
  }

  async createNewNote() {
    let newNoteGroup = new NoteGroupDataModel();
    newNoteGroup.ObjectId = this.ObjectId;
    newNoteGroup.ParentObjectName = this.ParentObjectName;
    newNoteGroup.PatientId = this.PatientID;

    let newDataNote = new NoteDataModel();
    newDataNote.Note = '';

    try {
      const result: NoteDataModel = await this.notesService.saveDataNote(newDataNote).toPromise();
      newDataNote = result;
      newNoteGroup.NoteId = newDataNote.NoteId;

      const groupResult: NoteGroupDataModel = await this.notesService.saveNoteGroup(newNoteGroup).toPromise();
      newNoteGroup = groupResult;
      newNoteGroup.isEditable = true;
      newNoteGroup.dataNote = newDataNote;
      this.dataNoteGroups.unshift(newNoteGroup);
    } catch (e) {
      this.messagingService.sendComponentMessage('notesDisplayWarning', {
        message: 'Whoops... something went wrong'
      });
    }

    if (this.scrollContainer) {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }
  }
}
